import { render, staticRenderFns } from "./DocumentThumbnails.vue?vue&type=template&id=072e163d&scoped=true&"
import script from "./DocumentThumbnails.vue?vue&type=script&lang=js&"
export * from "./DocumentThumbnails.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_thumbnails.scss?vue&type=style&index=0&id=072e163d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e163d",
  null
  
)

export default component.exports